import React, { useState, useEffect } from "react";
import { Formik, useField } from "formik";
import * as yup from "yup";
import {
  Box,
  Button,
  CircularProgress,
  TextField,
  Card,
  Grid,
  Typography,
  MenuItem,
  FormHelperText,
  InputLabel,
  FormControl,
  Select,
  IconButton,
} from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { styled } from "@mui/material/styles";
import swal from "sweetalert";
import Swal from "sweetalert2";
import imageCompression from "browser-image-compression";
import { PDFDocument } from "pdf-lib";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useAuth } from "../../../AuthProvider";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

// Define styled components
const StyledTextField = styled(TextField)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

const StyledButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(2),
}));

const FacebookCircularProgress = styled(CircularProgress)({
  color: "#3b5998",
});

const AllExaminationScheduleForm = () => {
  const [currentTab, setCurrentTab] = useState(0);
  const [loading, setLoading] = useState(true);
  const [btnloading, setBtnLoading] = useState(false);

  const navigate = useNavigate();
  const { userId, oId, pId, role ,board} = useAuth(); // Access userId from AuthContext
  const baseUrl = process.env.REACT_APP_API_BASE_URL;

  const [users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState("");
  const isPrincipal = role?.startsWith("PRINCIPAL") || false;
  const UserId = userId || selectedUsers;

  const [subjectOptions, setSubjectOptions] = useState([]);
  const [examTypeOptions, setExamTypeOptions] = useState([]);

  // const [classSectionData, setClassSectionData] = useState([]);
  // const [classOptions, setClassOptions] = useState([]);
  // const [sectionOptions, setSectionOptions] = useState([]);
  // const [selectedClass, setSelectedClass] = useState("Class-I");
  // const [selectedSection, setSelectedSection] = useState("Section-A");
//   const [courseOptions, setCourseOptions] = useState([]);
//   const [selectedCourseType, setSelectedCourseType] = useState("");


const [sscClassOptions, setSscClassOptions] = useState([]);
const [sscSectionOptions, setSscSectionOptions] = useState([]);
const [sscSelectedClass, setSscSelectedClass] = useState();
const [sscSelectedSection, setSscSelectedSection] = useState();

// INTERMEDIATE states
const [interSectionOptions, setInterSectionOptions] = useState([]);
const [interSelectedClass, setInterSelectedClass] = useState();
const [interSelectedSection, setInterSelectedSection] = useState();
const [courseOptions, setCourseOptions] = useState([]);
const [selectedCourseType, setSelectedCourseType] = useState("");

const [sscClassSectionMap, setSscClassSectionMap] = useState({});


  const today = new Date();
  today.setHours(0, 0, 0, 0);

  // Validation schema using yup
  const validationSchemaTab0 = yup.object().shape({
    // teacherName: yup
    //   .string()
    //   .required("Teacher Name is required")
    //   .matches(/^[a-zA-Z\s]+$/, "Teacher Name can only contain letters"),

    examTime: yup.string().required("Start Time is required"),
    examTimeEnd: yup.string().required("End Time is required"),
    examDate: yup
      .date()
      // .min(today, "Exam date cannot be in the past!") // Prevents past dates
      .required("Exam Date is required"),
    examType: yup.string().required("Exam Type is required"),

    // emailId: yup
    //   .string()
    //   .email("Invalid email format")
    //   .required("Email is required"),

    // contactNumber: yup
    //   .string()
    //   .required("Contact Number is required")
    //   .matches(/^\d+$/, "Contact Number can only contain numbers")
    //   .matches(/^[0-9]{10}$/, "Contact Number must be exactly 10 digits"),

    // romanNumberClass: yup.string().required("Class is required"),

    // sections: yup.string().required("Section is required"),

    // subject: yup.string().required("Subject is required"),

    // gender: yup.string().required("Gender is required"),
  });



// -------------------------------------------
//           For SSC functions
// -------------------------------------------

// ---- Fetch Class + Sections for SSC (School) ----
const fetchClassRegistrationData = async () => {
  try {
    const response = await fetch(`${baseUrl}/api/dynamic-classReg/class-registrations/${oId}/${pId}`);
    const data = await response.json();

    if (response.ok && Array.isArray(data)) {
      // Group by class and merge section strings into unique values
      const classSectionMap = {};

      data.forEach(item => {
        const className = item.classRegistration;
        const sectionList = item.sections.split(",").map(s => s.trim());

        if (!classSectionMap[className]) {
          classSectionMap[className] = new Set();
        }

        sectionList.forEach(section => classSectionMap[className].add(section));
      });

      const classes = Object.keys(classSectionMap);
      setSscClassOptions(classes); // Class dropdown options
      setSscClassSectionMap(classSectionMap); // Save for section filtering later

      // No default selection
      setSscSelectedClass("");
      setSscSelectedSection("");
      setSscSectionOptions([]);
    }
  } catch (error) {
    console.error("Error fetching SSC data:", error);
  }
};



// -------------------------------------------
//           For Intermediate functions
// -------------------------------------------

// ---- Fetch Courses for INTERMEDIATE ----
const fetchCourseData = async () => {
  if(!interSelectedClass) return;
  try {
    const response = await fetch(`${baseUrl}/api/dynamic-classReg/getAllcoursesAccordingClasses/${pId}?romanNumberClass=${interSelectedClass}`);
    const data = await response.json();
    if (response.ok && Array.isArray(data)) {
      setCourseOptions(data);
      // if (!selectedCourseType) {
      //   setSelectedCourseType(data || "");
      // }
    } else {
      setCourseOptions([]);
    }
  } catch (error) {
    console.error("Error fetching course data:", error);
    setCourseOptions([]);
  }
};

// ---- Fetch Sections for INTERMEDIATE ----
const fetchSectionsData = async () => {
  if (!interSelectedClass || !selectedCourseType) {
    setInterSectionOptions([]);
    return;
  }
  try {
    const response = await fetch(
      `${baseUrl}/api/dynamic-classReg/getAllClass-registrations/${interSelectedClass}/${selectedCourseType}/${pId}`
    );
    const data = await response.json();
    if (response.ok && Array.isArray(data) && data.length > 0) {
      const sectionsString = data[0].sections;  // because your data is like [{ sections: "Section-A,Section-B" }]
      const sections = sectionsString.split(",").map(section => section.trim());
      
      setInterSectionOptions(sections);

      if (sections.length > 0) {
        setInterSelectedSection(sections[0]);
      } else {
        setInterSelectedSection("");
      }
    } else {
      setInterSectionOptions([]);
      setInterSelectedSection("");
    }
  } catch (error) {
    console.error("Error fetching INTERMEDIATE data:", error);
  }
};





useEffect(() => {
  const loadClassData = async () => {
    if (board === "INTERMEDIATE") {
      await fetchSectionsData();
    } else if (board === "SSC") {
      await fetchClassRegistrationData();
    }
  };
  loadClassData();
}, [board,interSelectedClass, selectedCourseType, oId]);  // Removed selectedClass dependency here

// SSC: When selected class changes, update its sections
// useEffect(() => {
//   const updateSectionOptions = async () => {
//     try {
//       const response = await fetch(`${baseUrl}/api/dynamic-classReg/class-registrations/${oId}`);
//       const data = await response.json();
//       if (response.ok && Array.isArray(data)) {
//         const selectedClassData = data.find(item => item.classRegistration === sscSelectedClass);
//         if (selectedClassData) {
//           const sections = selectedClassData.sections.split(",");
//           setSscSectionOptions(sections);
//           setSscSelectedSection(sections.includes("Section-A") ? "Section-A" : sections[0]);
//         } else {
//           setSscSectionOptions([]);
//           setSscSelectedSection("");
//         }
//       }
//     } catch (error) {
//       console.error("Error updating SSC sections:", error);
//     }
//   };

//   if (board === "SSC" && sscSelectedClass) {
//     updateSectionOptions();
//   }
// }, [sscSelectedClass, board, oId]);

// INTERMEDIATE: When class or course type changes, update sections
// useEffect(() => {
//   const updateIntermediateSections = async () => {
//     if (board === "INTERMEDIATE" && interSelectedClass && selectedCourseType) {
//       await fetchSectionsData();
//     }
//   };
//   updateIntermediateSections();
// }, [interSelectedClass, selectedCourseType, board]);




// Fetch course options if board is INTERMEDIATE
useEffect(() => {
  if (board === "INTERMEDIATE") {
    fetchCourseData();
  }
}, [interSelectedClass,board, oId]);





     //select subject api 
     const fetchSubjectOptions = async () => {
      try {
        const selectedClass = sscSelectedClass || interSelectedClass;
        if (!selectedClass) return;
       
        // For INTERMEDIATE, ensure course type is also selected
        if (board === "INTERMEDIATE" && !selectedCourseType) return;
    
        let response;
    
        if (board === "SSC") {
          response = await fetch(`${baseUrl}/api/dynamic-classReg/getAllSubjects/by-class/${pId}?classRegistration=${selectedClass}`);
        } else if (board === "INTERMEDIATE") {
          response = await fetch(`${baseUrl}/api/dynamic-classReg/getAllSubjectsIntermediate/by-class/${pId}?classRegistration=${selectedClass}&course=${selectedCourseType}`);
        }
    
        if (!response) return;
    
        const data = await response.json();
    
        if (response.ok && Array.isArray(data) && typeof data[0] === 'string') {
          const subjectsArray = data[0].split(',').map((name, index) => ({
            id: index + 1,
            name: name.trim(),
          }));
          setSubjectOptions(subjectsArray);
        } else {
          setSubjectOptions([]);
        }
      } catch (error) {
        console.error("Error fetching subject options:", error);
        setSubjectOptions([]);
      }
    };
    
    
    useEffect(() => {
      if (oId && (sscSelectedClass || interSelectedClass)) {
        fetchSubjectOptions();
      }
    }, [oId, sscSelectedClass, interSelectedClass,selectedCourseType]); // Add selectedClass dependencies
    

      //select exam type api 
      const fetchExamTypeOptions = async () => {
        try {
          const selectedClass = sscSelectedClass || interSelectedClass;
          if (!selectedClass) return; // Don't call API if no class selected

           // For INTERMEDIATE, ensure course type is also selected
          if (board === "INTERMEDIATE" && !selectedCourseType) return;
      
          let response;
    
          if (board === "SSC") {
            response = await fetch(`${baseUrl}/api/dynamic-classReg/getAllExamsType/by-class/${pId}?classRegistration=${selectedClass}`);
          } else if (board === "INTERMEDIATE") {
            response = await fetch(`${baseUrl}/api/dynamic-classReg/getAllExamsType/by-class/${pId}?classRegistration=${selectedClass}&course=${selectedCourseType}`);
          }
      
          if (!response) return;

          // const response = await fetch(
          //   `${baseUrl}/api/dynamic-classReg/getAllExamsType/by-class/${oId}?classRegistration=${selectedClass}`
          // );
          const data = await response.json();
      
          if (response.ok && Array.isArray(data) && typeof data[0] === 'string') {
            const examsArray = data[0].split(',').map((name, index) => ({
              value: name.trim().toUpperCase().replace(/\s+/g, '_'),
              label: name.trim(),
            }));
            setExamTypeOptions(examsArray);
          } else {
            setExamTypeOptions([]);
          }
        } catch (error) {
          console.error("Error fetching exam types:", error);
          setExamTypeOptions([]);
        }
      };
      
      useEffect(() => {
        if (oId && (sscSelectedClass || interSelectedClass)) {
          fetchExamTypeOptions();
        }
      }, [oId, sscSelectedClass, interSelectedClass,selectedCourseType]); // Watch class & oId
      
    


  const getValidationSchema = () => {
    switch (currentTab) {
      case 0:
        return validationSchemaTab0;
      // Add cases for other tabs if needed
      default:
        return validationSchemaTab0; // Default schema
    }
  };

  //  new handle submit code

  const handleSubmit = async (values) => {
    // Show confirmation dialog
    const result = await Swal.fire({
      title: "Schedule Exam",
      text: "Are you sure you want to Schedule New Exam?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Confirm",
      cancelButtonText: "Cancel",
    });

    // Stop execution if user cancels
    if (!result.isConfirmed) return;

    setBtnLoading(true);
    try {
      // Sanitize values (convert empty/null values)
      // const sanitizedValues = Object.fromEntries(
      //   Object.entries(values).map(([key, val]) => [
      //     key,
      //     val === "" || val === "null" ? null : val,
      //   ])
      // );
      const sanitizedValues = Object.fromEntries(
  Object.entries(values).map(([key, val]) => [
    key,
    val === "" || val === "null" ? null : val,
  ])
);


      const formData = new FormData();

      // Append values to FormData
      Object.entries(sanitizedValues).forEach(([key, val]) => {
        if (val !== null) {
          formData.append(key, val);
        }
      });

      // ✅ Log all form data being sent
console.log("Sending data:");
for (const pair of formData.entries()) {
  console.log(`${pair[0]}: ${pair[1]}`);
}

      const apiEndpoint = `${baseUrl}/api/examCell/save/${UserId}`;

      // Make API call
      const response = await fetch(apiEndpoint, {
        method: "POST",
        body: formData,
      });

      const responseText = await response.text();

      if (response.ok) {
        // ✅ Show toast AFTER response is successful
        toast.success("Exam Registered Successfully!", {
          position: "top-right",
          autoClose: 1000, // Toast shows for 2 seconds
        });

        // ✅ Wait 2 seconds after success before navigating
        setTimeout(() => {
          navigate(-1);
        }, 1200);
      } else {
            const errorMessage = responseText || "Failed to submit form.";
            toast.error(errorMessage, { position: "top-right", autoClose: 2000 });
          }
      //     else {
      //   console.error("Error submitting the form:", response.text());
      //   toast.error(`Error: ${response.text()}`, {
      //     position: "top-right",
      //     autoClose: 2000,
      //   });
      // }
    } catch (error) {
      console.error("Error submitting the form", error);
      toast.error("Unexpected error occurred!", {
        position: "top-right",
        autoClose: 2000,
      });
    } finally {
      setBtnLoading(false); // ✅ Stop loading AFTER API response
    }
  };

  
    const fetchUsers = async () => {
      try {
        const response = await fetch(
          `${baseUrl}/api/principal/getAllUserIdsAndNames/EXAMINATION_CELL/${oId}/${pId}`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch users");
        }
        const data = await response.json();
        setUsers(data);
        if (data.length > 0) {
          setSelectedUsers(data[0].userId); // ✅ Set first record's userId as default
        }
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };
   useEffect(() => {
     if (isPrincipal) {
       fetchUsers();
     }
   }, [oId]); // ✅ Only runs on mount 

  const genderOptions = [
    { value: "male", label: "Male" },
    { value: "female", label: "Female" },
    { value: "other", label: "Other" },
  ];

  // Initial form values
  const initialValues = {
    // teacherName: "",
    examTime: "",
    examTimeEnd: "",
    examDate: "",
    // emailId: "",
    // contactNumber: "",
    romanNumberClass: "",
    course:"",
    sections: "",
    subject: "",
    // gender: "",
    examType: "",
  };
  return (
    <Box marginTop={9}>
      <Formik
        initialValues={initialValues}
        validationSchema={getValidationSchema()}
        onSubmit={handleSubmit}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          validateForm,
          setFieldValue,
          setTouched,
        }) => (
          <form
            onSubmit={(e) => {
              e.preventDefault(); // Prevent the default form submission behavior
              handleSubmit(values); // Call the handleSubmit function with form values
            }}
          >
            <Box display="flex" flexDirection="column" alignItems="center">
              <Card
                sx={{
                  padding: 2,
                  backgroundColor: "#fff",
                  width: "96%",
                  height: "60%",
                }}
              >
                {/* <Typography variant="h3" sx={{textAlign:'center'}}>Registration</Typography>
                 */}
                {currentTab === 0 && (
                  <Box>
                    <Box
                      display="flex"
                      alignItems="center"
                      sx={{ marginBottom: 2 }}
                    >
                      <IconButton
                        onClick={() => navigate(-1)}
                        sx={{ color: "#2e2a54" }}
                      >
                        <KeyboardBackspaceIcon fontSize="medium" />
                      </IconButton>
                      <Typography
                        variant="h4"
                        component="h3"
                        sx={{ fontWeight: "bold" }}
                      >
                        Schedule New Examination
                      </Typography>
                    </Box>
                    <Box
                      display="grid"
                      gap="30px"
                      gridTemplateColumns="repeat(3, minmax(0, 1fr))"
                    >

{board === "SSC" && (
  <>
   <FormControl size="medium">
  <InputLabel id="class-select-label">Select Class</InputLabel>
  <Select
    labelId="class-select-label"
    // value={sscSelectedClass}
    // onChange={(e) => setSscSelectedClass(e.target.value)}
    label="Select Class"

    name="romanNumberClass"
    value={values.romanNumberClass}
    onChange={(e) => {
      const selected = e.target.value;

      // ✅ Formik handleChange
      handleChange(e);

      // ✅ Your custom logic
      setSscSelectedClass(selected);
      const sections = sscClassSectionMap[selected]
        ? Array.from(sscClassSectionMap[selected])
        : [];
      setSscSectionOptions(sections);
      setSscSelectedSection(
        sections.includes("Section-A") ? "Section-A" : sections[0] || ""
      );
    }}
    onBlur={handleBlur}
  >
    {sscClassOptions.length > 0 ? (
      sscClassOptions.map((cls) => (
        <MenuItem key={cls} value={cls}>
          {cls}
        </MenuItem>
      ))
    ) : (
      <MenuItem disabled>No classes available</MenuItem>
    )}
  </Select>
</FormControl>

<FormControl size="medium">
  <InputLabel id="section-select-label">Select Section</InputLabel>
  <Select
    labelId="section-select-label"
    // value={sscSelectedSection}
    // onChange={(e) => setSscSelectedSection(e.target.value)}
    label="Select Section"

    name="sections"
        value={values.sections}
        onChange={(e) => {
          const selected = e.target.value;
          handleChange(e); // updates Formik state
          setSscSelectedSection(selected); // optional: update your component state if used elsewhere
        }}
        onBlur={handleBlur}
    
  >
    {sscSectionOptions.length > 0 ? (
      sscSectionOptions.map((section) => (
        <MenuItem key={section} value={section}>
          {section}
        </MenuItem>
      ))
    ) : (
      <MenuItem disabled>No sections available</MenuItem>
    )}
  </Select>
</FormControl>

  </>
)}


{board === "INTERMEDIATE" && (
  <>
    <FormControl size="medium" >
      <InputLabel id="intermediate-class-select-label">Select Year</InputLabel>
      <Select
        labelId="intermediate-class-select-label"
        // value={interSelectedClass}
        // onChange={(e) => setInterSelectedClass(e.target.value)}
        label="Select Year"
        name="romanNumberClass"
        value={values.romanNumberClass}
        onChange={(e) => {
          const selected = e.target.value;
          handleChange(e); // updates Formik state
          setInterSelectedClass(selected); // optional: update your component state if used elsewhere
        }}
        onBlur={handleBlur}
      >
        <MenuItem value="Inter-1st-Year">Inter-1st-Year</MenuItem>
        <MenuItem value="Inter-2nd-Year">Inter-2nd-Year</MenuItem>
      </Select>
    </FormControl>

    <FormControl size="medium">
  <InputLabel id="course-type-label">Select Course</InputLabel>
  <Select
    labelId="course-type-label"
    // value={selectedCourseType}

    name="course"
    value={values.course}
    onChange={(e) => {
      const selected = e.target.value;
      handleChange(e); // updates Formik state
      setSelectedCourseType(selected); // optional: update your component state if used elsewhere
    }}
    onBlur={handleBlur}

    // onChange={(e) => setSelectedCourseType(e.target.value)}
    label="Select Course"
  >
    {courseOptions.length > 0 ? (
      courseOptions.map((course, index) => (
        <MenuItem key={index} value={course}>
          {course}
        </MenuItem>
      ))
    ) : (
      <MenuItem disabled>No courses available</MenuItem>
    )}
  </Select>
</FormControl>


    <FormControl fullWidth size="medium">
  <InputLabel id="intermediate-section-select-label">Select Section</InputLabel>
  <Select
    labelId="intermediate-section-select-label"
    // value={interSelectedSection}
    // onChange={(e) => setInterSelectedSection(e.target.value)}
    label="Select Section"

    name="sections"
        value={values.sections}
        onChange={(e) => {
          const selected = e.target.value;
          handleChange(e); // updates Formik state
          setInterSelectedSection(selected); // optional: update your component state if used elsewhere
        }}
        onBlur={handleBlur}
  >
    {interSectionOptions.length > 0 ? (
      interSectionOptions.map((section, index) => (
        <MenuItem key={index} value={section}>
          {section}
        </MenuItem>
      ))
    ) : (
      // <MenuItem disabled>No sections available for selected Year and Course</MenuItem>
      <MenuItem disabled value="">
      {board === "INTERMEDIATE"
        ? "No available sections for selected Year and Course"
        : "No available sections for selected Class"}
    </MenuItem>
    )}
  </Select>
</FormControl>

  </>
)}

<FormControl fullWidth size="medium" error={touched.subject && Boolean(errors.subject)}>
  <InputLabel>Select Subject</InputLabel>
  <Select
    name="subject"
    value={values.subject}
    onChange={handleChange}
    onBlur={handleBlur}
    label="Select Subject"
  >
    {subjectOptions.length > 0 ? (
      subjectOptions.map((subject) => (
        <MenuItem key={subject.id} value={subject.name}>
          {subject.name}
        </MenuItem>
      ))
    ) : (
      <MenuItem disabled value="">
        {board === "INTERMEDIATE"
          ? "No available subjects for selected Year and Course"
          : "No available subjects for selected Class"}
      </MenuItem>
    )}
  </Select>
  {touched.subject && errors.subject && (
    <FormHelperText>{errors.subject}</FormHelperText>
  )}
</FormControl>

<FormControl fullWidth size="medium" error={touched.examType && Boolean(errors.examType)}>
  <InputLabel>Exam Type</InputLabel>
  <Select
    label="Exam Type"
    name="examType"
    value={values.examType}
    onChange={handleChange}
    onBlur={handleBlur}
    sx={{ height: 54 }}
   
  >
    {examTypeOptions.length > 0 ? (
      examTypeOptions.map((type) => (
        <MenuItem key={type.value} value={type.value}>
          {type.label}
        </MenuItem>
      ))
    ) : (
      
      <MenuItem disabled value="">
      {board === "INTERMEDIATE"
        ? "No available examType for selected Year and Course"
        : "No available examType for selected Class"}
    </MenuItem>
    )}
  </Select>

  {touched.examType && errors.examType && (
    <Typography color="error" variant="body2">
      {errors.examType}
    </Typography>
  )}
</FormControl>

                      <StyledTextField
                        fullWidth
                        type="date"
                        label="Exam Date"
                        InputLabelProps={{ shrink: true }} // Ensures the label stays visible
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.examDate || ""} // Ensures it does not show "undefined"
                        name="examDate"
                        autoComplete="off"
                        error={Boolean(touched.examDate && errors.examDate)}
                        helperText={
                          touched.examDate && errors.examDate
                            ? errors.examDate
                            : ""
                        }
                        style={{ marginBottom: "20px" }}
                      />

                      {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <TimePicker
                          label="Exam Start Time"
                          value={
                            values.examTime
                              ? dayjs(values.examTime, "hh:mm A")
                              : null
                          }
                          onChange={(newValue) => {
                            handleChange({
                              target: {
                                name: "examTime",
                                value: newValue
                                  ? newValue.format("hh:mm A")
                                  : "",
                              },
                            });
                          }}
                          onBlur={handleBlur}
                          ampm
                          sx={{ width: "100%"}}
                          slotProps={{
                            textField: {
                              fullWidth: true,
                              sx: { mb: 1 },
                              error: Boolean(
                                touched.examTime && errors.examTime
                              ),
                              helperText:
                                touched.examTime && errors.examTime
                                  ? errors.examTime
                                  : " ",
                            },
                          }}
                        />
                      </LocalizationProvider> */}
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
  <TimePicker
    label="Exam Start Time"
    value={
      values.examTime
        ? dayjs(values.examTime, "hh:mm A")
        : null
    }
    onChange={(newValue) => {
      handleChange({
        target: {
          name: "examTime",
          value: newValue
            ? newValue.format("hh:mm A")
            : "",
        },
      });
    }}
    onBlur={handleBlur}
    ampm
    sx={{ width: "100%" }}
    slotProps={{
      textField: {
        fullWidth: true,
        sx: {
          mb: 1,
          mt: board === "INTERMEDIATE" ? -3.5 : 1,
        },
        error: Boolean(touched.examTime && errors.examTime),
        helperText:
          touched.examTime && errors.examTime
            ? errors.examTime
            : " ",
      },
    }}
  />
</LocalizationProvider>

                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <TimePicker
                          label="Exam End Time"
                          value={
                            values.examTimeEnd
                              ? dayjs(values.examTimeEnd, "hh:mm A")
                              : null
                          }
                          onChange={(newValue) => {
                            handleChange({
                              target: {
                                name: "examTimeEnd",
                                value: newValue
                                  ? newValue.format("hh:mm A")
                                  : "",
                              },
                            });
                          }}
                          onBlur={handleBlur}
                          ampm
                          sx={{ width: "100%"}}
                          slotProps={{
                            textField: {
                              fullWidth: true,
                              sx: { mt: -3.5 },
                              error: Boolean(
                                touched.examTimeEnd && errors.examTimeEnd
                              ),
                              helperText:
                                touched.examTimeEnd && errors.examTimeEnd
                                  ? errors.examTimeEnd
                                  : " ",
                            },
                          }}
                        />
                      </LocalizationProvider>

                      {/* <StyledTextField
                        fullWidth
                        type="number"
                        label="Contact Number"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.contactNumber}
                        name="contactNumber"
                        autoComplete="off"
                        error={
                          !!touched.contactNumber && !!errors.contactNumber
                        }
                        helperText={
                          touched.contactNumber && errors.contactNumber
                        }
                      /> */}

                      {/* <StyledTextField
                        fullWidth
                        type="email"
                        label="Email"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.emailId}
                        name="emailId"
                        autoComplete="off"
                        error={!!touched.emailId && !!errors.emailId}
                        helperText={touched.emailId && errors.emailId}
                      /> */}

                      {/* Dropdown for Select User - Right Next to Date Selection */}
                      {/* {isPrincipal && (
                        <Grid item xs={12} sm={14}sx={{ mt: -3.5}} >
                          {" "}
                        
                          <FormControl
                            fullWidth
                            variant="outlined"
                            size="medium"
                          >
                            <InputLabel>Select Examination Admin</InputLabel>
                            <Select
                              value={selectedUsers}
                              onChange={(e) => setSelectedUsers(e.target.value)}
                              label="Select Examination Admin"
                              // sx={{ height: "36px", display: "flex", alignItems: "center" }} // Matching height
                            >
                              {users.map((user) => (
                                <MenuItem key={user.userId} value={user.userId}>
                                  {user.userId} - {user.firstName}{" "}
                                  {user.lastName}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                      )} */}
                    </Box>
                    <Box display="flex" justifyContent="flex-end" marginTop={1}>
                      <StyledButton
                        type="submit"
                        variant="contained"
                        style={{
                          width: "130px",
                          fontWeight:'bold',
                          backgroundColor: btnloading ? "#6E69B0" : "#3C3972", // Different color when loading
                          "&:hover": { backgroundColor: "#58548E" },
                          color: "#fff",
                          cursor: btnloading ? "not-allowed" : "pointer", // Prevent clicks when loading
                          opacity: btnloading ? 0.7 : 1, // Reduce opacity when loading
                        }}
                        disabled={btnloading}
                        onClick={async (e) => {
                          e.preventDefault(); // Prevent default form submission

                          setTouched({
                            // teacherName: true,
                            examTime: true,
                            examTimeEnd: true,
                            examDate: true,
                            examType: true, // Added missing examType
                            // emailId: true,
                            // contactNumber: true,
                            // romanNumberClass: true, // Added missing className
                            // sections: true, // Added missing section
                            // subject: true, // Added missing subject
                            // gender: true, // Added missing gender
                          });

                          // Trigger form validation
                          const errors = await validateForm();

                          if (Object.keys(errors).length === 0) {
                            handleSubmit(values); // No errors, submit the form
                          }
                        }}
                      >
                        {btnloading ? (
                          <>
                            <FacebookCircularProgress
                              size={20}
                              sx={{ color: "#fff", marginRight: "8px" }}
                            />
                            Loading...
                          </>
                        ) : (
                          "Submit"
                        )}
                      </StyledButton>
                    </Box>
                  </Box>
                )}
              </Card>
            </Box>
          </form>
        )}
      </Formik>
      <ToastContainer position="top-right" autoClose={1000} />
    </Box>
  );
};

export default AllExaminationScheduleForm;